import { Badge, IconButton } from '@ksyos/design-system';
import { AccountRequestStatus } from '@common/enums/accountRequestStatus';
import { getSelectedLanguage } from '@frontend/translate';
import { hasAccountRequestAuthorization } from '@frontend/utils';
import { useAccountRequestContext } from '@frontend/utils/hooks/useAccountRequestContext';

export function AccountRequestCardHeaderAction() {
    const language = getSelectedLanguage();
    const { isEditing, accountRequest, setIsEditing, needsKsyosApproval } = useAccountRequestContext();
    const hasUpdateAuthorization = hasAccountRequestAuthorization('update');

    if (
        hasUpdateAuthorization &&
        accountRequest.status === AccountRequestStatus.pending &&
        (isEditing || needsKsyosApproval)
    ) {
        return null;
    }

    if (!hasUpdateAuthorization && accountRequest.status === AccountRequestStatus.pending) {
        return (
            <Badge
                color="blue"
                size="large"
                text={language.accountRequest.pending}
            />
        );
    }

    if (accountRequest.status === AccountRequestStatus.rejected) {
        return (
            <Badge
                color="red"
                size="large"
                text={language.accountRequest.rejected}
            />
        );
    }

    if (accountRequest.status === AccountRequestStatus.approved) {
        return (
            <Badge
                color="green"
                size="large"
                text={language.accountRequest.approved}
            />
        );
    }

    return (
        <IconButton
            icon="edit-light"
            onClick={() => setIsEditing(true)}
        />
    );
}
